export default __webpack_public_path__ + "static/media/academic.979e954c.svg";